// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"426b90ca","900":"c054e3db"}[chunkId] + ".chunk.js";
};